import {DonorTypes, Group, GroupsPayload} from "./types";

export default class GroupManager {
    public constructor(private readonly groups: GroupsPayload) {}

    /**
     * Gets a sorted list of groups in ascending order by ID for a given donor type.
     */
    public getGroupsForType(type: DonorTypes): Group[] {
        const lowerCaseType = type.toLowerCase() as keyof Omit<GroupsPayload, 'is_production'>;
        if (lowerCaseType === DonorTypes.INDIVIDUAL.toLowerCase()) {
            return [];
        }

        return this.groups[lowerCaseType] || [];
    }

    /**
     * Generates the display text for a combobox option.
     */
    public static getOptionText(group: Group, withDayTime: boolean = true): string {
        const parts = [group.group_id];
        if (group.name) {
            parts.push(group.name);
        }
        if (withDayTime && group.day && group.local_time) {
            const timeParts = [group.day, group.local_time];
            if (group.timezone) {
                timeParts.push(group.timezone);
            }
            parts.push(timeParts.join(' '));
        }

        return parts.join(' - ');
    }
}